import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AirValidationSectorVm } from '@app/entities/air-validation.response';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-small-reservation-date-info',
  templateUrl: './small-reservation-date-info.component.html',
  styleUrls: ['./small-reservation-date-info.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SmallReservationDateInfoComponent {

  @Input() sectors: AirValidationSectorVm[];
  
  public readonly icon = Icon;

  public readonly fontFamily = TypographyFontFamily;
  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;

  constructor() { }

  public isOneWay(first: boolean, last: boolean): boolean {
    return first && last;
  }

}
